export const LESSON_EXPAND = ['lesson_publish_states', 'product_assignment', 'course_email_ids']
